import { render } from "./Section_External_Locations.vue?vue&type=template&id=ec01fb04"
import script from "./Section_External_Locations.vue?vue&type=script&lang=js"
export * from "./Section_External_Locations.vue?vue&type=script&lang=js"

import "./Section_External_Locations.vue?vue&type=style&index=0&id=ec01fb04&lang=scss"
script.render = render

export default script